import React, { useState, useEffect } from 'react';
import api from '../../../config/axios';
import Swal from 'sweetalert2';
import { FaFilter, FaChevronDown, FaChevronRight, FaPlus, FaEdit, FaExchangeAlt } from 'react-icons/fa';
import Paginacao from '../../../components/utils/paginacao';
import NovoLancamento from './modals/NovoLancamento';
import EditarLancamento from './modals/EditarLancamento';
import DatePicker from '../../../components/utils/datepicker';
import moment from 'moment';

const LancamentosFinanceiros = () => {

    const [activeTab, setActiveTab] = useState('lancamentos');

    const [receitasData, setReceitasData] = useState([]);
    const [receitasCurrentPage, setReceitasCurrentPage] = useState(1);
    const [receitasTotalPages, setReceitasTotalPages] = useState(1);
    const [receitasExpandedRows, setReceitasExpandedRows] = useState(new Set());
    const [totalReceitas, setTotalReceitas] = useState(0);
    const [totalRegistrosReceitas, setTotalRegistrosReceitas] = useState(0);

    const [despesasData, setDespesasData] = useState([]);
    const [despesasCurrentPage, setDespesasCurrentPage] = useState(1);
    const [despesasTotalPages, setDespesasTotalPages] = useState(1);
    const [despesasExpandedRows, setDespesasExpandedRows] = useState(new Set());
    const [totalDespesas, setTotalDespesas] = useState(0);
    const [totalRegistrosDespesas, setTotalRegistrosDespesas] = useState(0);

    const [transferenciasData, setTransferenciasData] = useState([]);
    const [transferenciasCurrentPage, setTransferenciasCurrentPage] = useState(1);
    const [transferenciasTotalPages, setTransferenciasTotalPages] = useState(1);
    const [transferenciasExpandedRows, setTransferenciasExpandedRows] = useState(new Set());
    const [totalTransferencias, setTotalTransferencias] = useState(0);
    const [totalRegistrosTransferencias, setTotalRegistrosTransferencias] = useState(0);

    const [filtros, setFiltros] = useState({
        data_criacao_inicio: null,
        data_criacao_fim: null,
        numero_lancamento: '',
        ver_excluidos: false
    });

    const [showModalLancamento, setShowModalLancamento] = useState(false);
    const [showModalEditar, setShowModalEditar] = useState(false);
    const [lancamentoSelecionado, setLancamentoSelecionado] = useState(null);

    const limit = 10;

    useEffect(() => {
        fetchReceitas(receitasCurrentPage);
        fetchDespesas(despesasCurrentPage);
        fetchTransferencias(transferenciasCurrentPage);
    }, [receitasCurrentPage, despesasCurrentPage, transferenciasCurrentPage]);

    const fetchReceitas = async (page, filtrosParams = filtros) => {
        try {
            Swal.fire({
                title: 'Carregando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                page: page,
                limit: limit,
                ...filtrosParams
            };

            const response = await api.get('/lancamentos-financeiros/receitas', { params });

            setReceitasData(response.data.records || []);
            setReceitasTotalPages(response.data.totalPages || 1);
            setTotalReceitas(response.data.totalReceitas || 0);
            setTotalRegistrosReceitas(response.data.totalRegistros || 0);
            setReceitasExpandedRows(new Set());

            Swal.close();
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar receitas', 'error');
        }
    };

    const fetchDespesas = async (page, filtrosParams = filtros) => {
        try {
            Swal.fire({
                title: 'Carregando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                page: page,
                limit: limit,
                ...filtrosParams
            };

            const response = await api.get('/lancamentos-financeiros/despesas', { params });

            setDespesasData(response.data.records || []);
            setDespesasTotalPages(response.data.totalPages || 1);
            setTotalDespesas(response.data.totalDespesas || 0);
            setTotalRegistrosDespesas(response.data.totalRegistros || 0);
            setDespesasExpandedRows(new Set());

            Swal.close();
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar despesas', 'error');
        }
    };

    const fetchTransferencias = async (page, filtrosParams = filtros) => {
        try {
            Swal.fire({
                title: 'Carregando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                page: page,
                limit: limit,
                ...filtrosParams
            };

            const response = await api.get('/lancamentos-financeiros/transferencias', { params });

            setTransferenciasData(response.data.records || []);
            setTransferenciasTotalPages(response.data.totalPages || 1);
            setTotalTransferencias(response.data.totalTransferencias || 0);
            setTotalRegistrosTransferencias(response.data.totalRegistros || 0);
            setTransferenciasExpandedRows(new Set());

            Swal.close();
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar transferências', 'error');
        }
    };

    const handleFiltrar = () => {
        const filtrosConvertidos = {
            data_criacao_inicio: filtros.data_criacao_inicio ? moment(filtros.data_criacao_inicio).format('YYYY-MM-DD') : '',
            data_criacao_fim: filtros.data_criacao_fim ? moment(filtros.data_criacao_fim).format('YYYY-MM-DD') : '',
            numero_lancamento: filtros.numero_lancamento || '',
            ver_excluidos: filtros.ver_excluidos
        };

        setReceitasCurrentPage(1);
        setDespesasCurrentPage(1);
        setTransferenciasCurrentPage(1);

        fetchReceitas(1, filtrosConvertidos);
        fetchDespesas(1, filtrosConvertidos);
        fetchTransferencias(1, filtrosConvertidos);
    };

    const limparFiltros = () => {
        const filtrosLimpos = {
            data_criacao_inicio: null,
            data_criacao_fim: null,
            numero_lancamento: '',
            ver_excluidos: false
        };
        setFiltros(filtrosLimpos);
        setReceitasCurrentPage(1);
        setDespesasCurrentPage(1);
        setTransferenciasCurrentPage(1);

        fetchReceitas(1, { data_criacao_inicio: '', data_criacao_fim: '', numero_lancamento: '', ver_excluidos: false });
        fetchDespesas(1, { data_criacao_inicio: '', data_criacao_fim: '', numero_lancamento: '', ver_excluidos: false });
        fetchTransferencias(1, { data_criacao_inicio: '', data_criacao_fim: '', numero_lancamento: '', ver_excluidos: false });
    };

    const formatarData = (dataString) => {
        if (!dataString) return '-';

        if (dataString.includes('-')) {
            const [ano, mes, dia] = dataString.split('-');
            const data = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
            return data.toLocaleDateString('pt-BR');
        }

        const data = new Date(dataString);
        return data.toLocaleDateString('pt-BR');
    };

    const formatarDataHora = (dataString) => {
        if (!dataString) return '-';

        const data = new Date(dataString);
        const dataFormatada = data.toLocaleDateString('pt-BR');
        const horaFormatada = data.toLocaleTimeString('pt-BR');

        return `${dataFormatada} ${horaFormatada}`;
    };

    const formatarValor = (valor) => {
        if (!valor) return 'R$ 0,00';
        return parseFloat(valor).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    };

    const formatarTipoTransferencia = (tipo) => {
        const tipos = {
            'aplicacao': 'Aplicação',
            'aprovisionamento': 'Aprovisionamento',
            'pagamento_cartao': 'Pagamento de Cartão',
            'resgate': 'Resgate',
            'saque': 'Saque',
            'transferencia': 'Transferência'
        };
        return tipos[tipo] || tipo || '-';
    };

    const formatarOrigem = (origem) => {
        const origens = {
            'caixa': 'Caixa',
            'banco': 'Banco',
            'manual': 'Manual'
        };
        return origens[origem] || origem || '-';
    };

    const formatarFormaPagamento = (forma) => {
        const formas = {
            'dinheiro': 'Dinheiro',
            'cartao_credito': 'Cartão de Crédito',
            'cartao_debito': 'Cartão de Débito',
            'pix': 'PIX',
            'cheque': 'Cheque',
            'boleto': 'Boleto',
            'ted': 'TED',
            'doc': 'DOC'
        };
        return formas[forma] || forma || '-';
    };

    const formatarStatus = (status) => {
        const statusMap = {
            'pendente': 'Pendente',
            'confirmado': 'Confirmado',
            'cancelado': 'Excluído',
            'vencido': 'Vencido',
            'pago': 'Pago',
            'estornado': 'Estornado',
            'conciliado': 'Conciliado'
        };
        return statusMap[status] || status;
    };

    const getCorStatus = (status) => {
        const cores = {
            'pendente': 'bg-warning',
            'confirmado': 'bg-success',
            'cancelado': 'bg-danger',
            'vencido': 'bg-secondary',
            'pago': 'bg-success',
            'estornado': 'bg-danger',
            'conciliado': 'bg-info'
        };
        return cores[status] || 'bg-secondary';
    };

    const getContrastColorTag = (hexColor) => {
        if (!hexColor) return '#000000';
        const hex = hexColor.replace('#', '');
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.5 ? '#000000' : '#ffffff';
    };

    const toggleRowExpansion = (lancamentoId, tipo) => {
        if (tipo === 'receita') {
            const newExpandedRows = new Set(receitasExpandedRows);
            if (newExpandedRows.has(lancamentoId)) {
                newExpandedRows.delete(lancamentoId);
            } else {
                newExpandedRows.add(lancamentoId);
            }
            setReceitasExpandedRows(newExpandedRows);
        } else if (tipo === 'despesa') {
            const newExpandedRows = new Set(despesasExpandedRows);
            if (newExpandedRows.has(lancamentoId)) {
                newExpandedRows.delete(lancamentoId);
            } else {
                newExpandedRows.add(lancamentoId);
            }
            setDespesasExpandedRows(newExpandedRows);
        } else if (tipo === 'transferencia') {
            const newExpandedRows = new Set(transferenciasExpandedRows);
            if (newExpandedRows.has(lancamentoId)) {
                newExpandedRows.delete(lancamentoId);
            } else {
                newExpandedRows.add(lancamentoId);
            }
            setTransferenciasExpandedRows(newExpandedRows);
        }
    };

    const handleNovoLancamento = () => {
        setShowModalLancamento(true);
    };


    const handleSalvarLancamento = () => {
        fetchReceitas(receitasCurrentPage);
        fetchDespesas(despesasCurrentPage);
        fetchTransferencias(transferenciasCurrentPage);
    };

    const handleEditarLancamento = (lancamento) => {
        setLancamentoSelecionado(lancamento);
        setShowModalEditar(true);
    };

    const renderTable = (data, tipo, expandedRows, currentPage, totalPages, setCurrentPage, totalRegistros) => {
        return (
            <div>
                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead className="table-dark">
                            <tr>
                                <th style={{ width: '40px' }} title="Clique para expandir detalhes"></th>
                                <th className="text-nowrap">Nº</th>
                                <th className="text-nowrap">Data</th>
                                <th className="text-nowrap">{tipo === 'receita' ? 'Cliente/Origem' : 'Fornecedor/Destino'}</th>
                                <th className="text-nowrap">Origem</th>
                                <th className="text-nowrap">Valor</th>
                                <th className="text-nowrap">Status</th>
                                <th className="text-nowrap text-center" style={{ width: '120px' }}>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? (
                                data.map((lancamento) => (
                                    <React.Fragment key={lancamento.id}>
                                        <tr
                                            style={{ cursor: 'pointer' }}
                                            className="user-select-none"
                                            onClick={() => toggleRowExpansion(lancamento.id, tipo)}
                                            title="Clique para ver mais detalhes"
                                        >
                                            <td className="text-center">
                                                {expandedRows.has(lancamento.id) ?
                                                    <FaChevronDown className="text-primary" /> :
                                                    <FaChevronRight className="text-muted" />
                                                }
                                            </td>
                                            <td className="text-nowrap">
                                                {lancamento.numero_exibicao}
                                            </td>
                                            <td className="text-nowrap">
                                                {formatarData(lancamento.data_hora_lancamento)}
                                            </td>
                                            <td className="text-nowrap">
                                                {lancamento.tipo_transferencia ? (
                                                    tipo === 'receita'
                                                        ? lancamento.contaOrigem?.nome_exibicao || '-'
                                                        : lancamento.contaDestino?.nome_exibicao || lancamento.contaOrigem?.nome_exibicao || '-'
                                                ) : (lancamento.cliente?.nome || '-')}
                                            </td>
                                            <td className="text-nowrap">
                                                {lancamento.tipo_transferencia ? formatarTipoTransferencia(lancamento.tipo_transferencia) : formatarOrigem(lancamento.origem)}
                                            </td>
                                            <td className="text-nowrap">
                                                {formatarValor(Math.abs(lancamento.valor))}
                                            </td>
                                            <td className="text-nowrap">
                                                <span className={`badge ${getCorStatus(lancamento.status)}`}>
                                                    {formatarStatus(lancamento.status)}
                                                </span>
                                            </td>
                                            <td className="text-nowrap text-center">
                                                <button
                                                    className="btn btn-custom-secondary btn-sm"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleEditarLancamento(lancamento);
                                                    }}
                                                    title="Editar lançamento"
                                                >
                                                    <FaEdit />
                                                </button>
                                            </td>
                                        </tr>
                                        {expandedRows.has(lancamento.id) && (
                                            <tr>
                                                <td colSpan="8" className="bg-light">
                                                    <div className="p-3">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <h6 className="fw-bold mb-3">Informações Básicas</h6>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Gestora</small>
                                                                        <div className="text-muted">{lancamento.gestora?.nome || '-'}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Unidade</small>
                                                                        <div className="text-muted">{lancamento.unidade?.nome || '-'}</div>
                                                                    </div>
                                                                </div>
                                                                {lancamento.tipo_transferencia ? (
                                                                    <>
                                                                        <div className="row mb-2">
                                                                            <div className="col-sm-6">
                                                                                <small className="fw-bold">Tipo de Transferência</small>
                                                                                <div className="text-muted">{formatarTipoTransferencia(lancamento.tipo_transferencia)}</div>
                                                                            </div>
                                                                            <div className="col-sm-6">
                                                                                <small className="fw-bold">Conta Origem</small>
                                                                                <div className="text-muted">{lancamento.contaOrigem?.nome_exibicao || '-'}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row mb-2">
                                                                            <div className="col-sm-6">
                                                                                <small className="fw-bold">Conta Destino</small>
                                                                                <div className="text-muted">{lancamento.contaDestino?.nome_exibicao || '-'}</div>
                                                                            </div>
                                                                            <div className="col-sm-6">
                                                                                <small className="fw-bold">Número do Documento</small>
                                                                                <div className="text-muted">{lancamento.numero_doc || '-'}</div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className="row mb-2">
                                                                            <div className="col-sm-6">
                                                                                <small className="fw-bold">Cliente</small>
                                                                                <div className="text-muted">{lancamento.cliente?.nome || '-'}</div>
                                                                            </div>
                                                                            <div className="col-sm-6">
                                                                                <small className="fw-bold">Categoria</small>
                                                                                <div className="text-muted">{lancamento.categoria?.nome || '-'}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row mb-2">
                                                                            <div className="col-sm-6">
                                                                                <small className="fw-bold">Centro de Custo</small>
                                                                                <div className="text-muted">{lancamento.centroCusto?.nome || '-'}</div>
                                                                            </div>
                                                                            <div className="col-sm-6">
                                                                                <small className="fw-bold">Número do Documento</small>
                                                                                <div className="text-muted">{lancamento.numero_doc || '-'}</div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>

                                                            <div className="col-md-6">
                                                                <h6 className="fw-bold mb-3">Informações Financeiras</h6>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Valor</small>
                                                                        <div className="text-muted">{formatarValor(Math.abs(lancamento.valor))}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Multa/Juros</small>
                                                                        <div className="text-muted">{formatarValor(lancamento.multa_juro)}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Desconto/Taxa</small>
                                                                        <div className="text-muted">{formatarValor(lancamento.desconto_taxa)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Forma de Pagamento</small>
                                                                        <div className="text-muted">{formatarFormaPagamento(lancamento.forma_pagamento)}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Status</small>
                                                                        <div>
                                                                            <span className={`badge ${getCorStatus(lancamento.status)}`}>
                                                                                {formatarStatus(lancamento.status)}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Origem</small>
                                                                        <div className="text-muted">{formatarOrigem(lancamento.origem)}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Vai DRE</small>
                                                                        <div>
                                                                            <span className={`badge ${lancamento.vai_dre === 'S' ? 'bg-success' : 'bg-secondary'}`}>
                                                                                {lancamento.vai_dre === 'S' ? 'Sim' : 'Não'}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-3">
                                                            <div className="col-md-6">
                                                                <h6 className="fw-bold mb-3">Datas</h6>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Data/Hora Lançamento</small>
                                                                        <div className="text-muted">{formatarDataHora(lancamento.data_hora_lancamento)}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Vencimento</small>
                                                                        <div className="text-muted">{formatarData(lancamento.data_vencimento)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Competência</small>
                                                                        <div className="text-muted">{formatarData(lancamento.data_competencia)}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Pagamento</small>
                                                                        <div className="text-muted">{formatarData(lancamento.data_pagamento)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Crédito</small>
                                                                        <div className="text-muted">{formatarData(lancamento.data_credito)}</div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <h6 className="fw-bold mb-3">Auditoria</h6>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Criado Por</small>
                                                                        <div className="text-muted">{lancamento.criado_por || '-'}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Criado Em</small>
                                                                        <div className="text-muted">{formatarDataHora(lancamento.criado_em)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Alterado Por</small>
                                                                        <div className="text-muted">{lancamento.alterado_por || '-'}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Alterado Em</small>
                                                                        <div className="text-muted">{formatarDataHora(lancamento.alterado_em)}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {lancamento.tags && lancamento.tags.length > 0 && (
                                                            <div className="row mt-3">
                                                                <div className="col-12">
                                                                    <h6 className="fw-bold mb-2">Tags</h6>
                                                                    <div className="d-flex flex-wrap gap-1">
                                                                        {lancamento.tags.map(tag => (
                                                                            <span
                                                                                key={tag.id}
                                                                                className="badge"
                                                                                style={{
                                                                                    backgroundColor: tag.cor,
                                                                                    color: getContrastColorTag(tag.cor)
                                                                                }}
                                                                            >
                                                                                {tag.nome}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {lancamento.observacao && (
                                                            <div className="row mt-3">
                                                                <div className="col-12">
                                                                    <h6 className="fw-bold mb-2">Observação</h6>
                                                                    <div className="text-muted">
                                                                        {lancamento.observacao}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        {`Nenhum lançamento de ${tipo} encontrado`}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                        <span>
                            Total de registros: <strong>{totalRegistros}</strong>
                        </span>
                    </div>
                    <Paginacao
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />
                </div>
            </div>
        );
    };

    const renderTransferenciasTable = () => {
        return (
            <div>
                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead className="table-dark">
                            <tr>
                                <th style={{ width: '40px' }} title="Clique para expandir detalhes"></th>
                                <th className="text-nowrap">Nº</th>
                                <th className="text-nowrap">Data</th>
                                <th className="text-nowrap">Tipo</th>
                                <th className="text-nowrap">Origem → Destino</th>
                                <th className="text-nowrap">Valor</th>
                                <th className="text-nowrap">Status</th>
                                <th className="text-nowrap text-center" style={{ width: '120px' }}>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transferenciasData.length > 0 ? (
                                transferenciasData.map((transferencia) => (
                                    <React.Fragment key={transferencia.id}>
                                        <tr
                                            style={{ cursor: 'pointer' }}
                                            className="user-select-none"
                                            onClick={() => toggleRowExpansion(transferencia.id, 'transferencia')}
                                            title="Clique para ver mais detalhes"
                                        >
                                            <td className="text-center">
                                                {transferenciasExpandedRows.has(transferencia.id) ?
                                                    <FaChevronDown className="text-primary" /> :
                                                    <FaChevronRight className="text-muted" />
                                                }
                                            </td>
                                            <td className="text-nowrap">
                                                {transferencia.numero_exibicao}
                                            </td>
                                            <td className="text-nowrap">
                                                {formatarData(transferencia.data_hora_lancamento)}
                                            </td>
                                            <td className="text-nowrap">
                                                {formatarTipoTransferencia(transferencia.tipo_transferencia)}
                                            </td>
                                            <td className="text-nowrap">
                                                {transferencia.contaOrigem?.nome_exibicao || '-'} → {transferencia.contaDestino?.nome_exibicao || '-'}
                                            </td>
                                            <td className="text-nowrap">
                                                {formatarValor(Math.abs(transferencia.valor))}
                                            </td>
                                            <td className="text-nowrap">
                                                <span className={`badge ${getCorStatus(transferencia.status)}`}>
                                                    {formatarStatus(transferencia.status)}
                                                </span>
                                            </td>
                                            <td className="text-nowrap text-center">
                                                <button
                                                    className="btn btn-custom-secondary btn-sm"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleEditarLancamento(transferencia);
                                                    }}
                                                    title="Editar transferência"
                                                >
                                                    <FaEdit />
                                                </button>
                                            </td>
                                        </tr>
                                        {transferenciasExpandedRows.has(transferencia.id) && (
                                            <tr>
                                                <td colSpan="8" className="bg-light">
                                                    <div className="p-3">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <h6 className="fw-bold mb-3">Informações Básicas</h6>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Gestora</small>
                                                                        <div className="text-muted">{transferencia.gestora?.nome || '-'}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Unidade</small>
                                                                        <div className="text-muted">{transferencia.unidade?.nome || '-'}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Conta Origem</small>
                                                                        <div className="text-muted">{transferencia.contaOrigem?.nome_exibicao || '-'}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Conta Destino</small>
                                                                        <div className="text-muted">{transferencia.contaDestino?.nome_exibicao || '-'}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Tipo de Transferência</small>
                                                                        <div className="text-muted">{formatarTipoTransferencia(transferencia.tipo_transferencia)}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Número do Documento</small>
                                                                        <div className="text-muted">{transferencia.numero_doc || '-'}</div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <h6 className="fw-bold mb-3">Informações Financeiras</h6>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Valor</small>
                                                                        <div className="text-muted">{formatarValor(Math.abs(transferencia.valor))}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Multa/Juros</small>
                                                                        <div className="text-muted">{formatarValor(Math.abs(transferencia.multa_juro || 0))}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Desconto/Taxa</small>
                                                                        <div className="text-muted">{formatarValor(Math.abs(transferencia.desconto_taxa || 0))}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Forma de Pagamento</small>
                                                                        <div className="text-muted">{formatarFormaPagamento(transferencia.forma_pagamento)}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Status</small>
                                                                        <div>
                                                                            <span className={`badge ${getCorStatus(transferencia.status)}`}>
                                                                                {formatarStatus(transferencia.status)}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Origem</small>
                                                                        <div className="text-muted">{formatarOrigem(transferencia.origem)}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Vai DRE</small>
                                                                        <div>
                                                                            <span className={`badge ${transferencia.vai_dre === 'S' ? 'bg-success' : 'bg-secondary'}`}>
                                                                                {transferencia.vai_dre === 'S' ? 'Sim' : 'Não'}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-3">
                                                            <div className="col-md-6">
                                                                <h6 className="fw-bold mb-3">Datas</h6>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Data/Hora Lançamento</small>
                                                                        <div className="text-muted">{formatarDataHora(transferencia.data_hora_lancamento)}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Vencimento</small>
                                                                        <div className="text-muted">{formatarData(transferencia.data_vencimento)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Competência</small>
                                                                        <div className="text-muted">{formatarData(transferencia.data_competencia)}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Pagamento</small>
                                                                        <div className="text-muted">{formatarData(transferencia.data_pagamento)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Crédito</small>
                                                                        <div className="text-muted">{formatarData(transferencia.data_credito)}</div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <h6 className="fw-bold mb-3">Auditoria</h6>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Criado Por</small>
                                                                        <div className="text-muted">{transferencia.criado_por || '-'}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Criado Em</small>
                                                                        <div className="text-muted">{formatarDataHora(transferencia.criado_em)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Alterado Por</small>
                                                                        <div className="text-muted">{transferencia.alterado_por || '-'}</div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <small className="fw-bold">Alterado Em</small>
                                                                        <div className="text-muted">{formatarDataHora(transferencia.alterado_em)}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {transferencia.observacao && (
                                                            <div className="row mt-3">
                                                                <div className="col-12">
                                                                    <h6 className="fw-bold mb-2">Observação</h6>
                                                                    <div className="text-muted">
                                                                        {transferencia.observacao}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        Nenhuma transferência encontrada
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                        <span>
                            Total de registros: <strong>{totalRegistrosTransferencias}</strong>
                        </span>
                    </div>
                    <Paginacao
                        currentPage={transferenciasCurrentPage}
                        totalPages={transferenciasTotalPages}
                        onPageChange={setTransferenciasCurrentPage}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className="container-fluid">
            <div className="card">
                <div className="card-body">
                    <div className="row mt-3">
                        <div className="col-md-6">
                            <h4 className="fw-bold mb-0">Lançamentos Financeiros</h4>
                        </div>
                    </div>
                    
                    <div className="row mt-3 mb-3">
                        <div className="col-md-6 col-12">
                            <button className="btn btn-outline-primary" onClick={handleNovoLancamento}>
                                <FaPlus className="me-1" /> Novo Lançamento
                            </button>
                        </div>
                    </div>

                    <div className="row mb-4 align-items-end mt-4">
                        <div className="col-lg-2 col-12">
                            <label className="form-label fw-bold">Nº do Lançamento</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Digite o número"
                                value={filtros.numero_lancamento}
                                onChange={(e) => setFiltros(prev => ({ ...prev, numero_lancamento: e.target.value }))}
                            />
                        </div>
                        <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                            <label className="form-label fw-bold">Data De</label>
                            <DatePicker
                                selected={filtros.data_criacao_inicio}
                                onChange={(date) => setFiltros(prev => ({ ...prev, data_criacao_inicio: date }))}
                            />
                        </div>
                        <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                            <label className="form-label fw-bold">Data Até</label>
                            <DatePicker
                                selected={filtros.data_criacao_fim}
                                onChange={(date) => setFiltros(prev => ({ ...prev, data_criacao_fim: date }))}
                            />
                        </div>
                        <div className="col-lg-2 col-12 mt-lg-0 mt-3 d-flex align-items-end">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="verExcluidos"
                                    checked={filtros.ver_excluidos}
                                    onChange={(e) => setFiltros(prev => ({ ...prev, ver_excluidos: e.target.checked }))}
                                />
                                <label className="form-check-label" htmlFor="verExcluidos">
                                    Ver Excluídos
                                </label>
                            </div>
                        </div>
                        <div className="col-lg-2 col-12 mt-lg-0 mt-3 text-end">
                            <button className="btn btn-outline-secondary me-2" onClick={limparFiltros}>
                                Limpar
                            </button>
                            <button className="btn btn-custom-primary" onClick={handleFiltrar}>
                                <FaFilter className="me-1" /> Filtrar
                            </button>
                        </div>
                    </div>

                    <ul className="nav nav-tabs" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeTab === 'lancamentos' ? 'active' : ''}`}
                                onClick={() => setActiveTab('lancamentos')}
                                type="button"
                            >
                                Receitas e Despesas
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeTab === 'transferencias' ? 'active' : ''}`}
                                onClick={() => setActiveTab('transferencias')}
                                type="button"
                            >
                                Transferências
                            </button>
                        </li>
                    </ul>

                    <div className="tab-content mt-3">
                        {activeTab === 'lancamentos' && (
                            <div className="tab-pane fade show active">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <h5 className="fw-bold text-success d-inline">Receitas</h5>
                                            <div className="mt-2">
                                                <span className="fw-bold me-1">Total:</span>
                                                <span className="fw-bold text-success">{formatarValor(Math.abs(totalReceitas))}</span>
                                            </div>
                                        </div>
                                        {renderTable(receitasData, 'receita', receitasExpandedRows, receitasCurrentPage, receitasTotalPages, setReceitasCurrentPage, totalRegistrosReceitas)}
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <h5 className="fw-bold text-danger d-inline">Despesas</h5>
                                            <div className="mt-2">
                                                <span className="fw-bold me-1">Total:</span>
                                                <span className="fw-bold text-danger">{formatarValor(Math.abs(totalDespesas))}</span>
                                            </div>
                                        </div>
                                        {renderTable(despesasData, 'despesa', despesasExpandedRows, despesasCurrentPage, despesasTotalPages, setDespesasCurrentPage, totalRegistrosDespesas)}
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'transferencias' && (
                            <div className="tab-pane fade show active">
                                <div className="mb-3">
                                    <h5 className="fw-bold text-primary d-inline">Transferências</h5>
                                    <div className="mt-2">
                                        <span className="fw-bold me-1">Total:</span>
                                        <span className="fw-bold text-primary">{formatarValor(Math.abs(totalTransferencias))}</span>
                                    </div>
                                </div>
                                {renderTransferenciasTable()}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {showModalLancamento && (
                <NovoLancamento
                    onClose={() => setShowModalLancamento(false)}
                    onLancamentoAtualizado={handleSalvarLancamento}
                />
            )}

            {showModalEditar && (
                <EditarLancamento
                    lancamento={lancamentoSelecionado}
                    onClose={() => {
                        setShowModalEditar(false);
                        setLancamentoSelecionado(null);
                    }}
                    onLancamentoAtualizado={handleSalvarLancamento}
                />
            )}

        </div>
    );
};

export default LancamentosFinanceiros;